import { isAxiosError } from "axios";

/** True when the backend rejected the request with 409 (e.g. entity still in use). */
export function isConflictError(error: unknown): boolean {
	return isAxiosError(error) && error.response?.status === 409;
}
